import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { VueQueryPlugin } from "@tanstack/vue-query";
import mitt from "mitt";
import Vue3TouchEvents from "vue3-touch-events";

const emitter = mitt();
createApp(App)
  .use(router)
  .use(Vue3TouchEvents)
  .use(VueQueryPlugin)
  .provide("emitter", emitter)
  .mount("#app");
